/** Start of local calendar day (midnight). */
function startOfLocalDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
}

/**
 * Whole calendar days between `createdAt` and `from` (default: now).
 * Same calendar day → 0. Does not use hour/minute deltas.
 */
export function calendarDaysSince(createdAt: string, from: Date = new Date()): number {
  const created = new Date(createdAt)
  if (Number.isNaN(created.getTime())) return 0
  const diff = startOfLocalDay(from) - startOfLocalDay(created)
  return Math.round(diff / 86400000)
}

/** e.g. Today, 1 day ago, 5 days ago */
export function formatDaysSinceCreated(isoDate: string): string {
  const days = calendarDaysSince(isoDate)
  if (days <= 0) return "Today"
  if (days === 1) return "1 day ago"
  return `${days} days ago`
}

/** Tamil labels for sidebar / health cards */
export function formatDaysSinceCreatedTamil(isoDate: string): string {
  const days = calendarDaysSince(isoDate)
  if (days <= 0) return "இன்று"
  if (days === 1) return "1 நாள் முன்"
  return `${days} நாட்கள் முன்`
}
